// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true,
		//paginationType: boostPFSConfig.custom.endless_scroll ? 'infinite' : 'default',
		trackingProduct: '.boost-pfs-filter-products .product-item',
		trackingQuickView: '.trigger-quick-view ',
		trackingAddToCart: '.add-js.product__submit__add',
		trackingBuyNow: '.shopify-payment-button, #dynamic-checkout-cart',
      	filterTreeMobileStyle: 'style1'
	}
};

var isFirstLoad = true;

(function() {
	BoostPFS.inject(this);
  
	jQ('.boost-pfs-filter-tree-h').length > 0 ? boostPFSFilterConfig.general.separateRefineByFromFilter = true : boostPFSFilterConfig.general.separateRefineByFromFilter = false;
  
	ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {
		if (!data) data = this.data;

		if (!index) index = this.index;
		if (!totalProduct) totalProduct = this.totalProduct;

		console.log('%c ---- START ----', 'background: green; color: white');
		/* console.log('pr TITLE', data.title); */
		/* console.log('body', document.body.id); */
		console.log('NAME:', data.title);
		console.log('PrData', data);
		/* console.log(data.metafields); */
		/*** Prepare data ***/
		var product = data;
		var images = data.images_info;
		var sold_out = !data.available; // Check a product is out of stock
		var on_sale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var mid_season_sale = false;
		var pre_black_friday = false;
		var black_friday = false;
		var thermocoperta = false;
		var new_collection = false;

        /* console.log('data.compare_at_price_min', data.compare_at_price_min);
		console.log('data.price_min', data.price_min); */
		var discount_percentage = '';
		if (product.compare_at_price_min && product.compare_at_price_min != 0) {
			discount_percentage = `${(Math.ceil(((data.price_min - data.compare_at_price_min)/data.compare_at_price_min)*100))}%`;
		}
		/* console.log('discount_percentage', discount_percentage); */

		data.metafields.forEach(element => {
			// console.log('elementcheck', element);
			if (element.key == 'mid_season_sale' && element.value == 'true') {
				/* console.log('mid_season_sale TRUE'); */
				mid_season_sale = true;
			}
			if (element.key == 'pre_blackfriday' && document.body.id == 'black-week') {
				/* console.log('pre_black_friday TRUE'); */
				pre_black_friday = true;
			}
			if (element.key == 'black_friday' && element.value == 'true') {
				console.log('black_friday TRUE');
				black_friday = true;
			}
		});
		/* console.log('data.tags', data.tags); */
		data.tags.forEach(element => {
			if (element == 'new_collection') {
				/* console.log('new_collection TRUE'); */
				new_collection = true;
			}
			if (element == 'thermocoperta') {
				// console.log('thermocoperta TRUE');
				thermocoperta = true;
			}
		});

		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}

		// console.log('pr. data', data);
		// console.log('pr. options_with_values', data.options_with_values);
		// console.log('pr. title', data.title);
		// console.log('pr. variants', data.variants);
		// console.log('pr. data', data);

		// Product Colors Number
		let color_index = data.options.indexOf('color');
		console.log('color_index', color_index);
		let my_colors_count = 0;
		if (color_index > -1) {
			my_colors_count = data.options_with_values[color_index].values.length;
		}
		let my_colors_string = my_colors_count + ' colori';
		if (my_colors_count == 1) {
			my_colors_string = my_colors_count + ' colore';
		}

		// console.log('my_swatches_json', window.my_swatches_json);
		// Product Colors Swatches
		var my_swatch_buttons = '';
		
		let variants_by_color = {}
		// data.variants.forEach(element => {
		// 	// console.log('element', element);

		// 	variants_by_color[element.option_color] = element;
		// });

		console.log('data', data);
		console.log('data.options_with_values', data.options_with_values);
		console.log("data['variants']", data['variants']);
		if (!data.options_with_values || data.options_with_values.length < 2) {
			console.log('data.options_with_values', data.options_with_values);
			console.log('%c' + data.title + ' - WRONG OPTIONS ALERT!', 'color: white; background: red; font-size: 14px; padding: 5px;');
		}
		else if (
			data.options_with_values[0].name.toLowerCase().indexOf('taglia') > -1
			|| data.options_with_values[0].name.toLowerCase().indexOf('colore') > -1
			|| data.options_with_values[1].name.toLowerCase().indexOf('taglia') > -1
			|| data.options_with_values[1].name.toLowerCase().indexOf('colore') > -1
		) {
			console.log('data.options_with_values', data.options_with_values);
			console.log('%c' + data.title + ' - WRONG OPTION ALERT!', 'color: white; background: red; font-size: 14px; padding: 5px;');
		}
		if (color_index > -1) {
			for (var i = 0; i < data['variants'].length; i++) {
				// let fidhfejf = data.options_with_values[color_index].values[i];
				console.log("---->", data['variants'][i].original_merged_options[color_index].replace('color:', ''));
				variants_by_color[data['variants'][i].original_merged_options[color_index].replace('color:', '')] = data['variants'][i];
			}
		}
		console.log('variants_by_color', variants_by_color);

		for (let key in variants_by_color) {
			console.log(key, variants_by_color[key]);

			let my_temp = matchColors(window.my_swatches_json, variants_by_color[key].original_merged_options[color_index].replace('color:', ''));
			// console.log('my_temp', my_temp);
			let my_bkg_img = '';
			if (my_temp.path) {
				my_bkg_img = 'background-image: url(&quot;//' + my_temp.path + '&quot;); background-size: cover; background-position: center center;';
			}
			let is_active = '';
			if (variants_by_color[key].available == false) {
				is_active = 'disabled';
			}
		
			my_swatch_buttons += '<span class="swatch__button" data-swatch-button="" data-tooltip="' + variants_by_color[key].original_merged_options[color_index].replace('color:', '') + '">';
			my_swatch_buttons += '<input type="radio" name="grouped" value="' + variants_by_color[key].original_merged_options[color_index].replace('color:', '') + '" id="' + data.id + '-' + variants_by_color[key].id + '" ' + is_active + ' data-wg-notranslate="manual">';
			my_swatch_buttons += '<label for="' + data.id + '-' + variants_by_color[key].id + '" data-swatch="' + variants_by_color[key].original_merged_options[color_index].replace('color:', '') + '" data-swatch-variant="' + variants_by_color[key].id + '" data-swatch-image="https://cdn.shopify.com/s/files/1/0571/8202/7929/products/4772024009654_001.jpg?v=1647947491" style="--swatch:' + my_temp.hex + '; ' + my_bkg_img + '">';
			my_swatch_buttons += '<span class="visually-hidden">' + variants_by_color[key].original_merged_options[color_index].replace('color:', '') + '</span>';
			my_swatch_buttons += '</label>';
			my_swatch_buttons += '</span>';
		}
		console.log('%c ---- STOP ----', 'background: red; color: white');
		// my_swatch_buttons += '<span class="swatch__button" data-swatch-button="" data-tooltip="Blu/Bordeaux">';
		// my_swatch_buttons += '<input type="radio" name="grouped" value="Blu/Bordeaux" id="7323248984217-41972881162393" data-wg-notranslate="manual">';
		// my_swatch_buttons += '<label for="7323248984217-41972881162393" data-swatch="Blu/Bordeaux" data-swatch-variant="41972881162393" data-swatch-image="https://cdn.shopify.com/s/files/1/0571/8202/7929/products/4772024009654_001.jpg?v=1647947491" style="--swatch:#888888; background-image: url(&quot;//cdn.shopify.com/s/files/1/0571/8202/7929/t/25/assets/blu-bordeaux.jpg&quot;); background-size: cover; background-position: center center;">';
		// my_swatch_buttons += '<span class="visually-hidden">Blu/Bordeaux</span>';
		// my_swatch_buttons += '</label>';
		// my_swatch_buttons += '</span>';

		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.product_grid_item_html;

		// variants_first_id
		itemHtml = itemHtml.replace(/{{variants_first_id}}/g, firstVariant.id);

		// grid_string
		itemHtml = itemHtml.replace(/{{grid_strings}}/g, boostPFSConfig.custom.grid_strings);
      
      	if (!boostPFSConfig.custom.product_grid_outline) {
          	itemHtml = itemHtml.replace(/{{border_class}}/g, 'product-item--borderless');
        } else {
        	itemHtml = itemHtml.replace(/{{border_class}}/g, '');
        }
      
      	if (boostPFSConfig.custom.product_grid_center) {
          	itemHtml = itemHtml.replace(/{{alignment_class}}/g, 'product-item--centered');
        } else {
        	itemHtml = itemHtml.replace(/{{alignment_class}}/g, '');
        }

		// double__image_class
		var double_image_class = '',
			double_img_html = '';
		if (images.length > 1 && boostPFSConfig.custom.image_hover_enable) {
			double_image_class = 'double__image';
			var bgset_image1 = bgset(images[1]);
			double_img_html = '<div class="product-item__bg__under lazyload" data-bgset="' + bgset_image1 + '"></div>';
		}
		itemHtml = itemHtml.replace(/{{double_image_class}}/g, double_image_class);
		itemHtml = itemHtml.replace(/{{double_img_html}}/g, double_img_html);

		// animation_delay_150
		var animation_delay_150 = '';
		var animation_delay = (1 % boostPFSConfig.custom.grid_int) * 1;
		var animation_delay_150 = animation_delay * 150;
		var animation_delay_duration_800 = animation_delay * 100 + 800;
		itemHtml = itemHtml.replace(/{{animation_delay_150}}/g, animation_delay_150);
		itemHtml = itemHtml.replace(/{{animation_delay_duration_800}}/g, animation_delay_duration_800);

		// bgset
		var bgset_image0 = images.length > 0 ? bgset(images[0]) : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{bgset_image0}}/g, bgset_image0);

		// over_image_content_html
		var over_image_content_html = '';
		if (mid_season_sale) {
			/* console.log('mid_season_sale HERE'); */
			over_image_content_html += boostPFSTemplate.mid_season_sale;
		} else if (pre_black_friday) {
			/* console.log('pre_black_friday HERE'); */
			over_image_content_html += boostPFSTemplate.pre_black_friday;
		} else if (black_friday) {
			/* console.log('black_friday HERE'); */
			over_image_content_html += boostPFSTemplate.black_friday;
		/* } else if (thermocoperta) {
			// console.log('thermocoperta HERE');
			over_image_content_html += boostPFSTemplate.thermocoperta; */
		} else if (new_collection) {
			/* console.log('new_collection HERE'); */
			over_image_content_html += boostPFSTemplate.new_collection;
		} else if (on_sale && boostPFSConfig.custom.hasOwnProperty('sale_tags_enable') && boostPFSConfig.custom.sale_tags_enable == true) {
			over_image_content_html += boostPFSTemplate.sale_label_html;
		}
		if (boostPFSConfig.custom.hasOwnProperty('quickview_enable') && boostPFSConfig.custom.quickview_enable == true) {
			over_image_content_html += boostPFSTemplate.quick_view_html;
		}

		/* console.log(over_image_content_html); */
		itemHtml = itemHtml.replace(/{{over_image_content_html}}/g, over_image_content_html);

		var featured_media_url = images.length > 0 ? Utils.optimizeImage(images[0].src, '540x') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{featured_media_url}}/g, featured_media_url);

		var animation_delay_100 = animation_delay * 100;
		var animation_delay_duration_100 = animation_delay * 100 + 100;
		itemHtml = itemHtml.replace(/{{animation_delay_100}}/g, animation_delay_100);
		itemHtml = itemHtml.replace(/{{animation_delay_duration_100}}/g, animation_delay_duration_100);

		// reviews_html
		itemHtml = itemHtml.replace(/{{reviews_html}}/g, boostPFSTemplate.reviews_html);

		// sale_class
		var sale_class = '';
		if (on_sale) {
			sale_class = 'sale';
		}
		itemHtml = itemHtml.replace(/{{sale_class}}/g, sale_class);

		// price_html
		var price_html = '';
		if (!sold_out) {
			if (on_sale) {
				price_html += '<span class="old-price">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + '</span>\n';
			}
			if (priceVaries) {
				price_html += boostPFSTemplate.from_label_html + '\n';
				price_html += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			} else {
				price_html += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			}
		} else {
			price_html += boostPFSTemplate.soldout_label_html;
		}
		itemHtml = itemHtml.replace(/{{price_html}}/g, price_html);

		var show_reviews = false;
		var itemQuickviewHtml = '';
		if (boostPFSConfig.custom.quickview_enable) {
			show_reviews = false;
			itemQuickviewHtml = boostPFSTemplate.quick_view_modal_html;
			if (boostPFSConfig.custom.enable_yotpo && boostPFSConfig.custom.yotpo_ID !== '') {
				show_reviews = true;
			} else if (boostPFSConfig.custom.enable_product_reviews) {
				show_reviews = true;
			}
		}
		itemHtml = itemHtml.replace(/{{itemQuickview}}/g, itemQuickviewHtml);
		itemHtml = itemHtml.replace(/{{show_reviews}}/g, show_reviews);

		itemHtml = itemHtml.replace(/{{ariaLabelQuickView}}/g, boostPFSConfig.label.quick_close + ' ' + boostPFSConfig.label.quick_view);
		itemHtml = itemHtml.replace(/{{enable_zoom}}/g, boostPFSConfig.custom.enable_zoom);
		itemHtml - itemHtml.replace(/{{enable_video_looping}}/g, boostPFSConfig.custom.enable_video_looping);

		

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		if (my_colors_count > 0) {
			itemHtml = itemHtml.replace(/{{my_product_colors_html}}/g, '<span class="grid__product-swatches-count" data-swatch-count="">' + my_colors_string + '</span>');
		} else {
			itemHtml = itemHtml.replace(/{{my_product_colors_html}}/g, '')
		}

		/* console.log('my_swatch_buttons', my_swatch_buttons); */

		itemHtml = itemHtml.replace(/{{my_swatch_buttons}}/g, my_swatch_buttons);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
        // discount percentage
		/* console.log('discount_percentage', discount_percentage); */
		itemHtml = itemHtml.replace(/{{discount_percentage}}/g, discount_percentage);

		return itemHtml;
	};

	function bgset(image) {
		var bgset = '';
		if (image) {
			var aspect_ratio = image.width / image.height;

			if (image.width > 180) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
			if (image.width > 360) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
			if (image.width > 540) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
			if (image.width > 720) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
			if (image.width > 900) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
			if (image.width > 1080) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
			if (image.width > 1296) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
			if (image.width > 1512) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
			if (image.width > 1728) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
			if (image.width > 1950) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
			if (image.width > 2100) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
			if (image.width > 2260) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
			if (image.width > 2450) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
			if (image.width > 2700) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
			if (image.width > 3000) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
			if (image.width > 3350) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
			if (image.width > 3750) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
			if (image.width > 4100) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 4100x ' + Math.round(4100 / aspect_ratio) + 'h,';
			bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
		}
		return bgset;
	}

	function matchColors(colors, name) {
		let bg = '#E5E5E5';
		let img = null;
		const path = window.theme.assets.base || '/';
		const comparisonName = name.toLowerCase().replace(/\s/g, '');
		const array = colors.colors;
  
		if (array) {
		  let indexArray = null;
  
		  const hexColorArr = array.filter((colorObj, index) => {
			const neatName = Object.keys(colorObj).toString().toLowerCase().replace(/\s/g, '');
  
			if (neatName === comparisonName) {
			  indexArray = index;
  
			  return colorObj;
			}
		  });
  
		  if (hexColorArr.length && indexArray !== null) {
			const value = Object.values(array[indexArray])[0];
			bg = value;
  
			if (value.includes('.jpg') || value.includes('.jpeg') || value.includes('.png') || value.includes('.svg')) {
			  img = `${path}${value}`;
			  bg = '#888888';
			}
		  }
		}
  
		return {
		  color: name,
		  path: img,
		  hex: bg,
		};
	  }

	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		var html = "";
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			// Build Previous
			var previousHtml = currentPage > 1 ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift("...");
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push("...");
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = "";
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == "...") {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += pageArr[iPage] == currentPage ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink("page", currentPage, pageArr[iPage]));
			}
			html = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		}

		return html;
	};

	ProductPaginationLoadMore.prototype.compileTotalTemplate = function() {
		/**
		 * If enable the Load previous feature and the evnet type is page:
		 * => Get the next loading page is from session storage OR get the next loading page from query param
		 */
		if (Utils.isLoadPreviousPagePaginationType() && this.parent.eventType == 'page') {
			this.nextPage = parseInt(window.sessionStorage.getItem(this.settings.sessionStorageCurrentNextPage));
		} else {
			this.nextPage = Globals.queryParams.page;
		}
		// Set from index
		var from = (this.nextPage - 1) * Globals.queryParams.limit + 1;
		var numberOfShowingProducts = jQ(Selector.products + ' > .product-item').length;
		if (numberOfShowingProducts) {
			from -= numberOfShowingProducts - Globals.queryParams.limit;
		}
		// Set to index
		var product_index = (this.nextPage - 1) * Globals.queryParams.limit + 1;
		var to = product_index + this.data.products.length - 1;
		this.toProduct = to;

		return this.getTemplate('total')
			.replace(/{{progressLabel}}/g, Labels.loadMoreTotal)
			.replace(/{{ from }}/g, from)
			.replace(/{{ to }}/g, to)
			.replace(/{{ total }}/g, this.totalProduct)
			.replace(/{{class.productLoadMore}}/g, Class.productLoadMore)
	}

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
			var sortingArr = Utils.getSortingList();
			var current_sort_param = Globals.queryParams.sort || boostPFSConfig.general.default_sort_by;
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = "";

				for (var k in sortingArr) {
					var active_class = '',
						aria_current_attr = '';
					if (current_sort_param == k) {
						active_class = ' popout-list__item--current';
						aria_current_attr = 'aria-current="true" ';
					}
					sortingItemsHtml += '<li class="popout-list__item ' + active_class + '">' +
						'<a class="popout-list__option" ' +
						'data-value="' + k + '" ' +
						'data-sort-title="' + sortingArr[k] + '" ' +
						'href="#" ' +
						aria_current_attr +
						'data-sort-link>' +
						'<span>' + sortingArr[k] + '</span>' +
						'</a>' +
						'</li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);

			}
		}
		return html;
	};

	ProductSorting.prototype.render = function() {
		jQ(Selector.topSorting).html(this.compileTemplate());
	};

	/**
	 * Bind the events on Sorting select box
	 */
	ProductSorting.prototype.bindEvents = function() {
		jQ(Selector.topSorting).find('li').click(function(event) {
          	event.preventDefault();
			jQ(this).siblings('li').removeClass('popout-list__item--current');
			jQ(this).addClass('popout-list__item--current');
			// Append "sort" param to url
			// Used to Scroll to the previous position after returning from Product page
			FilterApi.setParam('sort', jQ(this).find('a').data('value'));
			var current_sort_title = jQ(this).find('a').data('sort-title');
			jQ('.boost-pfs-top-sorting-current-value').text(current_sort_title);
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
          	jQ('.boost-pfs-top-sorting-current-value').trigger('click');
		})
	};

	var timeOut = null;
	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
		// Call function to get extra product html by ajax
		var outerCollection = document.querySelector('[data-section-type="collection"]');
		var outerSearch = document.querySelector('[data-section-type="search"]');

		if (typeof Shopify.theme != 'undefined' &&
			typeof Shopify.theme.sections != 'undefined' &&
			typeof Shopify.theme.sections.registered != 'undefined' &&
			typeof Shopify.theme.sections.registered['product-grid'] == 'function') {
			clearTimeout(timeOut);
			timeOut = setTimeout(function() {
				if (Utils.isSearchPage()) {
					if (outerSearch) {
						Shopify.theme.sections.registered['product-grid'](outerSearch);
					}
				} else {
					if (outerCollection) {
						Shopify.theme.sections.registered['product-grid'](outerCollection);
					}
				}
			}, 200);
		}

		this.customCounterSwatches = document.querySelectorAll('.grid__product-swatches-count');
		this.customCounterSwatches.forEach((item) => {
			// console.log('item', item);
			item.addEventListener("mouseenter", (event) => {
				// console.log('ENTER');
				// console.log('event', event);
				item.closest('[data-grid-link]').classList.add('no-events');
				item.nextElementSibling.classList.add('is-visible');
			});

			item.closest('[data-product-grid-item]').addEventListener('mouseleave', (event) => {
				// console.log('EXIT');
				item.closest('[data-grid-link]').classList.remove('no-events');
				item.nextElementSibling.classList.remove('is-visible');
			});
		});
		
	};

	

	// Build additional elements
	FilterResult.prototype.afterRender = function(data) {
		if (!data) data = this.data;
	};
  
  	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		/* console.log('filter data', data); */
		
		translateFilterAndSearch();

      	jQ('body').addClass('boost-pfs-filter-tree-open-body');
	};

	const targetHTMLNode = document.querySelector('html');

	if (targetHTMLNode) {
		const config = { attributes: true, childList: false, subtree: false };

		const callback = function(mutationsList, observer) {
			// console.log('test');
			// console.log('test', mutationsList, observer);
			translateFilterAndSearch();
		};

		const observer = new MutationObserver(callback);
		observer.observe(targetHTMLNode, config);
	}

	function translateFilterAndSearch() {
		const CURRENT_LANG = jQ("html").attr("lang");
		// const CURRENT_LANG = 'en';
		// console.log('CURRENT_LANG', CURRENT_LANG);

		fetch(window.theme.assets.filters)
          .then((response) => response.text())
          .then((filters) => {
            /* console.log('filters', filters); */
			const FILTERS_MAPPING = JSON.parse(filters);
			var filterTitle = document.querySelector('[data-collection-nav] [data-group-tags-enabled]');
			var sortingTitle = document.querySelector('.popout--sort .popout__toggle__text');
			var filterOptionsTitle = document.querySelectorAll('.boost-pfs-filter-option-title-text');
			var filterOptionsValues = document.querySelectorAll('.boost-pfs-filter-option-value');
			var sortingOptionsValues = document.querySelectorAll('[data-sort-link] span');
			filterOptionsValues.forEach((item) => {
				/* console.log('Filter Option Value', item.textContent); */
				let closestContent = item.closest('.boost-pfs-filter-option-content');
				let closest_content_option = jQ(jQ(closestContent).siblings('.boost-pfs-filter-option-title').find('.boost-pfs-filter-option-title-text')).text();
				item.textContent = FILTERS_MAPPING[closest_content_option] && FILTERS_MAPPING[closest_content_option]['submenu'] && FILTERS_MAPPING[closest_content_option]['submenu'][item.textContent] && FILTERS_MAPPING[closest_content_option]['submenu'][item.textContent][CURRENT_LANG] ? FILTERS_MAPPING[closest_content_option]['submenu'][item.textContent][CURRENT_LANG] : item.textContent;
			});
			filterOptionsTitle.forEach((item) => {
				/* console.log('Filter Option Title', item.textContent); */
				// console.log('FILTERS_MAPPING[item.textContent][title][CURRENT_LANG]', FILTERS_MAPPING[item.textContent] && FILTERS_MAPPING[item.textContent]['title'] && FILTERS_MAPPING[item.textContent]['title'][CURRENT_LANG] ? FILTERS_MAPPING[item.textContent]['title'][CURRENT_LANG] : '');
				item.textContent = FILTERS_MAPPING[item.textContent] && FILTERS_MAPPING[item.textContent]['title'] && FILTERS_MAPPING[item.textContent]['title'][CURRENT_LANG] ? FILTERS_MAPPING[item.textContent]['title'][CURRENT_LANG] : item.textContent;
			});
			sortingOptionsValues.forEach((item) => {
				/* console.log('Sorting Option Values', item.textContent); */
				item.textContent = FILTERS_MAPPING[item.textContent] && FILTERS_MAPPING[item.textContent]['title'] && FILTERS_MAPPING[item.textContent]['title'][CURRENT_LANG] ? FILTERS_MAPPING[item.textContent]['title'][CURRENT_LANG] : item.textContent;
			});
			var text_to_change = filterTitle.childNodes[0];
			text_to_change.nodeValue = 'FILTRO';
			text_to_change.nodeValue = FILTERS_MAPPING[text_to_change.nodeValue] && FILTERS_MAPPING[text_to_change.nodeValue]['title'] && FILTERS_MAPPING[text_to_change.nodeValue]['title'][CURRENT_LANG] ? FILTERS_MAPPING[text_to_change.nodeValue]['title'][CURRENT_LANG] : text_to_change.nodeValue;
			sortingTitle.textContent = 'ORDINA';
			sortingTitle.textContent = FILTERS_MAPPING[sortingTitle.textContent] && FILTERS_MAPPING[sortingTitle.textContent]['title'] && FILTERS_MAPPING[sortingTitle.textContent]['title'][CURRENT_LANG] ? FILTERS_MAPPING[sortingTitle.textContent]['title'][CURRENT_LANG] : sortingTitle.textContent;
          })
          .catch((error) => {
            console.log(error);
          });

		// let temp = _.indexBy(data.filter.options, 'label');
		// /* console.log('temp', temp); */
		// let temp2 = _.indexBy(temp['Ambiente'].values, 'key');
		/* console.log('temp2', temp2); */

		// data.filter.options.forEach(element => {
		// 	if (element.filterType == 'tag') {
		// 		/* console.log('element.label', element.label); */
		// 		/* console.log('FILTERS_MAPPING[element.label]', FILTERS_MAPPING[element.label]); */
		// 		element.values.forEach(val => {
		// 			val.key = FILTERS_MAPPING[element.label] && FILTERS_MAPPING[element.label][val.key] ? FILTERS_MAPPING[element.label][val.key] : val.key;
		// 		});
		// 		element.label = FILTERS_MAPPING[element.label] && FILTERS_MAPPING[element.label].label ? FILTERS_MAPPING[element.label].label : element.label;
		// 	}
		// });
	}
})();